module.exports = __webpack_public_path__ + "static/media/WSJ_bw.5ee7943b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/press/WSJ_bw.png
 ** module id = 2379
 ** module chunks = 44
 **/